// Hinglish (Latin phonetic) -> Hindi (Devanagari) transliteration via Google Input Tools.
// Transliterates only ASCII-letter words; leaves Devanagari, digits and punctuation untouched.
// Falls back to the original text on any network/parse error.

async function wordCandidates(word) {
  try {
    const url = `https://inputtools.google.com/request?text=${encodeURIComponent(
      word
    )}&itc=hi-t-i0-und&num=4&cp=0&cs=1&ie=utf-8&oe=utf-8`;
    const j = await (await fetch(url)).json();
    if (j[0] === "SUCCESS" && j[1]?.[0]?.[1]?.length) return j[1][0][1];
  } catch (e) {
    /* fall through */
  }
  return [word];
}

// Up to n distinct full-text Hindi spellings for a Hinglish input.
export async function hindiSuggestions(text, n = 3) {
  const parts = String(text || "").split(/([A-Za-z]+)/);
  const cands = await Promise.all(parts.map((p) => (/^[A-Za-z]+$/.test(p) ? wordCandidates(p) : [p])));
  const out = [];
  for (let k = 0; k < 4 && out.length < n; k++) {
    const s = cands.map((c) => c[k] ?? c[0]).join("").trim();
    if (s && !/[A-Za-z]/.test(s) && !out.includes(s)) out.push(s);
  }
  return out;
}

export async function hinglishToHindi(text) {
  if (!text) return text || "";
  const tokens = String(text).split(/(\s+)/);
  const results = await Promise.all(
    tokens.map(async (tok) => {
      if (/^\s*$/.test(tok) || !/[a-zA-Z]/.test(tok)) return tok;
      const m = tok.match(/^([A-Za-z]+)([^A-Za-z]*)$/);
      const word = m ? m[1] : tok;
      const trail = m ? m[2] : "";
      try {
        const url = `https://inputtools.google.com/request?text=${encodeURIComponent(
          word
        )}&itc=hi-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8`;
        const res = await fetch(url);
        const j = await res.json();
        if (j[0] === "SUCCESS" && j[1]?.[0]?.[1]?.[0]) return j[1][0][1][0] + trail;
      } catch (e) {
        /* fall through */
      }
      return tok;
    })
  );
  return results.join("");
}
